import type { AccountType, PortfolioMandate } from './enums';

export function accountTypeForMandate(mandate: PortfolioMandate): AccountType {
  return mandate === 'LONG_TERM_INVESTING' ? 'LONG_TERM_INVEST' : 'ACTIVE_TRADING';
}

export function mandateForAccountType(accountType: AccountType): PortfolioMandate {
  return accountType === 'LONG_TERM_INVEST' ? 'LONG_TERM_INVESTING' : 'SWING_TRADING';
}

export function isSwingTradingMandate(mandate: PortfolioMandate): boolean {
  return mandate === 'SWING_TRADING';
}

export function isLongTermInvestingMandate(mandate: PortfolioMandate): boolean {
  return mandate === 'LONG_TERM_INVESTING';
}
